<div class="top-info d-flex ai-center jc-space-between">
  <div class="top-content_title d-flex ai-center">
    <h1 class="proyect-name">Nombre del proyecto</h1>
    <h2>Nombre del ciclo de prueba</h2>
  </div>
  <div class="top-content_info d-flex ai-center">
    <div class="date-ciclo_start">
      <p class="subtitle-txt">Fecha de inicio:</p>
      <p>10/10/2022</p>
    </div>
    <div class="date-ciclo_end">
      <p class="subtitle-txt">Fecha de ejecución:</p>
      <p>10/10/2022</p>
    </div>
    <div class="status-ciclo">
      <p class="subtitle-txt">Estado caso de prueba:</p>
      <p>Por hacer</p>
    </div>
  </div>
  <div class="link-actions d-flex ai-center">
    <a class="link">Editar</a>
    <a class="link">Eliminar</a>
    <a class="link">Ejecutar caso de prueba</a>
  </div>
</div>
